<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">AML Check Client {{clientNo}}</h5>
  <div class="d-flex gap-2 ms-auto">
    <button type="button" 
            class="btn btn-success btn-sm" 
            (click)="refresh()" 
            *ngIf="creditCheckData.checkResult==null">
      <fa-icon [icon]="faSync"></fa-icon>
    </button>
    <button type="button" 
            class="btn btn-outline-secondary btn-sm" 
            (click)="openHistory()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body" *ngIf="dataLoaded && creditCheckData!=null">

  <!-- Results View -->
  <div *ngIf="creditCheckData.checkResult!=null">
    <div class="card mb-3">
      <div class="card-body">
        <table class="table table-sm">
          <tbody>
            <tr *ngIf="creditCheckData.isManualCheck">
              <th style="width: 30%;">Manually Checked</th>
              <td>Yes</td>
            </tr>
            <tr *ngIf="creditCheckData.isManualCheck">
              <th>Checked Date</th>
              <td>{{creditCheckData.manualCheckDate | date: 'dd/MM/yyyy'}}</td>
            </tr>
            <tr *ngIf="!creditCheckData.isManualCheck">
              <th>Checked Date</th>
              <td>{{creditCheckData.checkPerformedDate | date: 'dd/MM/yyyy'}}</td>
            </tr>
            <tr>
              <th>By User</th>
              <td>{{creditCheckData.checkPerformedByUser.fullName}}</td>
            </tr>
            <tr *ngIf="creditCheckData.notes != null">
              <th>Notes</th>
              <td>{{creditCheckData.notes}}</td>
            </tr>
            <tr *ngIf="!creditCheckData.isManualCheck">
              <th>Result</th>
              <td>
                <fa-icon *ngIf="creditCheckData.checkResultString == 'PASS'" 
                         [icon]="faCheckCircle" 
                         class="text-success me-1"></fa-icon>
                <fa-icon *ngIf="creditCheckData.checkResultString != 'PASS'" 
                         [icon]="faExclamationCircle" 
                         class="text-danger me-1"></fa-icon>
                {{creditCheckData.checkResultString}}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Alerts Section -->
        <div *ngIf="!creditCheckData.isManualCheck && creditCheckData.hasErrors != true">
          <hr>
          <h6>Alerts</h6>
          <div>
            <span *ngIf="!creditCheckData.pepAlert">
              <fa-icon [icon]="faCheckCircle" class="text-success me-1"></fa-icon>
              No PEP Alerts
            </span>
            <span *ngIf="creditCheckData.pepAlert">
              <fa-icon [icon]="faExclamationCircle" class="text-danger me-1"></fa-icon>
              International PEP (Enhanced)
            </span>
          </div>
        </div>

        <!-- Errors Section -->
        <div *ngIf="creditCheckData.hasErrors == true" class="text-danger">
          <hr>
          <h6>Errors</h6>
          <span>
            <fa-icon [icon]="faExclamationCircle" class="me-1"></fa-icon>
            {{creditCheckData.errorMessage}}
          </span>
        </div>

        <!-- Search Details -->
        <hr>
        <h6>Search Details</h6>
        <table class="table table-sm">
          <tbody>
            <tr>
              <th style="width: 30%;">Forename</th>
              <td>{{creditCheckData.firstName}}</td>
            </tr>
            <tr>
              <th>Other Names</th>
              <td>{{creditCheckData.otherNames || '-'}}</td>
            </tr>
            <tr>
              <th>Surname</th>
              <td>{{creditCheckData.surname}}</td>
            </tr>
            <tr>
              <th>Date of Birth</th>
              <td>{{creditCheckData.dateOfBirth | date: 'dd-MM-yyyy'}}</td>
            </tr>
            <tr>
              <th>Building No</th>
              <td>{{creditCheckData.buildingNo}}</td>
            </tr>
            <tr>
              <th>Building Name</th>
              <td>{{creditCheckData.buildingName}}</td>
            </tr>
            <tr>
              <th>Street</th>
              <td>{{creditCheckData.street}}</td>
            </tr>
            <tr>
              <th>City</th>
              <td>{{creditCheckData.city}}</td>
            </tr>
            <tr>
              <th>Postcode</th>
              <td>{{creditCheckData.postCode}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-end" *ngIf="authService.isPortalManager() || authService.isPortalAdmin()">
      <button type="button" 
              class="btn btn-outline-secondary" 
              (click)="unlock()"
              *ngIf="creditCheckData.checkResult!=null || creditCheckData.cancelledByUserId">
        <fa-icon [icon]="faLock" class="me-1"></fa-icon>
        Unlock
      </button>
    </div>
  </div>

  <!-- Form View -->
  <form [formGroup]="creditSafeCheck" autocomplete="off" *ngIf="creditCheckData.checkResult==null">

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Title</label>
      <div class="col-sm-9">
        <select class="form-select" formControlName="titleId" (change)="updateField()">
          <option *ngFor="let title of titleList" [ngValue]="title.id">{{title.titleName}}</option>
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Forename</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="firstName" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Other Names</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="otherNames" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Surname</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="surname" (change)="updateField()">
      </div>
    </div>

   <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Date of Birth</label>
      <div class="col-sm-9">
        <input type="date" 
              class="form-control" 
              formControlName="dob" 
              (change)="onDateChange()" 
              required>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Building No</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="buildingNo" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Building Name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="buildingName" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Street</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="street" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">City</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="city" (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Postcode</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="postCode" (change)="updateField()">
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button type="button" 
              class="btn btn-outline-secondary" 
              (click)="runManualCreditSafecheck()"
              *ngIf="authService.isPortalManager() || authService.isPortalAdmin()">
        Manually Checked
      </button>

      <div>
        <button type="button" 
                class="btn btn-success" 
                (click)="runCreditSafecheck()"
                [disabled]="!creditSafeCheck.valid"
                *ngIf="!showSpinner">
          Check
        </button>
        <div *ngIf="showSpinner" class="spinner-border text-success" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

  </form>

</div>

<div class="modal-body text-center" *ngIf="!dataLoaded">
  <div class="spinner-border text-success" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>